module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QQDDB0sMleSMgAAACtJREFUOMtj/P//PwMlgImBQkCxAYwMDAz/h7YXWBiGfCyMRiMDA+PQz0wAdK8KFaMoNAUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_mpb_glp.png
// module id = UFb/
// module chunks = 0